export function isNumberValid (number)
{
	return number.match(/^[\d ]+$/g);
}